
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import './ChatSidebar.css';

import SocialLogin from './SocialLogin/SocialLogin';
import ChangePassword from './Forms/ChangePassword';
import Login from './Forms/Login';
import Register from './Forms/Register';
import UserName from './Forms/UserName';

import ChatController from '../../controllers/Chat';

import { hashCode, IE11_safeIncludes } from '../../helpers/utils';

const Forms = {
  ChangePassword: 'changePassword',
  Login: 'login',
  Register: 'register',
  UserName: 'username',
};

class ChatSidebar extends Component {

  constructor( props) {
    super( props);
    const { chatConfiguration } = props;
    const { sessionToken = '' } = chatConfiguration;

    this.loadMessages = this.loadMessages.bind( this);
    this.setForm = this.setForm.bind( this);
    this.clearForm = this.clearForm.bind( this);
    this.setLogin = this.setLogin.bind( this);
    this.setUserName = this.setUserName.bind( this);
    this.publishMessage = this.publishMessage.bind( this);
    this.renderTitleBox = this.renderTitleBox.bind( this);
    this.renderMessageBox = this.renderMessageBox.bind( this);
    this.renderInputBox = this.renderInputBox.bind( this);
    this.renderForm = this.renderForm.bind( this);

    const [ renderForm, login ] = sessionToken ? [ Forms.ChangePassword, true ] : [ null, false ];

    this.state = {
      messagesList: [],
      renderForm,
      login,
      sessionToken,
      showingChat: true,
      showDate: props.chatConfiguration.showDateAtStart,
      showTime: true,
      showOptions: false,
    };
    
    this.refreshInterval = null;
    this.mustSetUserName = !props.chatConfiguration.hasRegister;
    this.userName = null;
    this.mustScroll = true;
    this.lastMessage = null;
    this.mustFocus = true;
    this.inputField = { value: '' };
    this.waitingPublish = false;
  }

  async loadMessages() {
    const messagesList = await ChatController.loadMessages( this.props.chatConfiguration);
    this.setState({ messagesList });
  }

  setForm( form) {
    this.setState({ renderForm: form });
  }

  clearForm() {
    this.setState({ renderForm: null });
  }

  setLogin( sessionToken) {
    this.setState({ renderForm: null, login: true, sessionToken });
  }

  async setUserName( userName) {
    this.mustSetUserName = false;
    this.userName = userName;
    await this.publishMessage();
    this.setState({ renderForm: null });
  }

  async publishMessage() {
    if( this.mustSetUserName) {
      this.setForm( Forms.UserName);
    } else if( !this.waitingPublish) {
      if( this.props.chatConfiguration.hasRegister && !this.state.login) {
        alert( 'Publicar mensajes en este chat requiere estar logueado.');
      } else {
        this.waitingPublish = true;
        try {
          const response = await ChatController.publishMessage( this.props.chatConfiguration, this.state.sessionToken, this.inputField.value, this.userName);
          // if( response.msg) alert( response.msg);    // DEBUG
          this.mustScroll = true;
          this.waitingPublish = false;
          await this.loadMessages();
          this.inputField.value = '';
        } catch( error) {
          // if( error.msg) alert( error.msg);    // DEBUG
          this.mustSetUserName = !this.props.chatConfiguration.hasRegister;
        }
      }
    }
  }

  renderTitleBox() {
    const logout = _ => {
      this.setState({ login: false });
    };
    const renderLoggedButtons = _ => (
      <div>
        <button className={'btn-chat'} onClick={ _ => this.setForm( Forms.ChangePassword) }> Change password </button>
        <button className={'btn-chat btn-margin'} onClick={ logout }> Logout </button>
      </div>
    );
    const renderUnloggedButtons = _ => (
      <div>
        <button className={'btn-chat'} onClick={ _ => this.setForm( Forms.Register) }> Sign Up </button>
        <button className={'btn-chat btn-margin'} onClick={ _ => this.setForm( Forms.Login) }> Log In </button>
      </div>
    );
    const renderSessionButtons = _ => (
      <div className={'column-8'}>
        <div className='btn-group pull-right'>
          { this.state.login ? renderLoggedButtons() : renderUnloggedButtons() }
        </div>
      </div>
    );
    return (
      <div className={`title-box ${this.props.chatConfiguration.hasRegister ? 'has-register' : ''}`}>
        <div className={this.props.chatConfiguration.hasRegister ? 'column-4' : ''}>
          <h5> Chat </h5>
        </div>
        { this.props.chatConfiguration.hasRegister ? renderSessionButtons() : <div/> }
        <hr />
      </div>
    );
  }

  renderMessageBox() {
    const DateOptions = { year: 'numeric', month: '2-digit', day: 'numeric' };
    const HourOptions = { hour: '2-digit', minute: '2-digit'};

    const updateLastMessage = ref => {
      const lastMessage = ReactDOM.findDOMNode( ref);
      if( lastMessage) this.lastMessage = lastMessage;
    };

    const styleMessage = message => {
      const colors = [ 'red', 'blue', 'green', 'brown', 'fuchsia', 'black', 'orange'];
      const userId = message.userId ? message.userId : hashCode( message.userName);
      if( !this.baseColor) this.baseColor = Math.floor( Math.random() * colors.length);
      return { color: colors[ ( userId + this.baseColor ) % colors.length]};
    };

    const buildAnonymousUserName = message => {
      let userName = message.userName;
      let className = '';
      if( !userName || userName === '') {
        userName = '"Anonymous"';
        className = 'anonymous';
      }
      return <b className={ className }>{ userName }</b>;
    };

    const renderMessage = (message, i) => (
      <div key={i} className={'message'} ref={ updateLastMessage }>
        { this.state.showDate ?
          <span className={'date'}><i>{ new Date( message.date).toLocaleDateString( 'es-ES', DateOptions) } </i></span>
        : <div/>}
        { this.state.showTime ?
          <span className={'date'}>{ new Date( message.date).toLocaleTimeString( 'es-ES', HourOptions) } </span>
        : <div/>}
        <span style={ styleMessage( message) }>{ buildAnonymousUserName( message ) } :</span>
        { message.deleted ? <span><i> This message was deleted.</i></span> : <span> { message.text }</span> }
      </div>
    );

    return (
      <div className={`message-box ${this.props.chatConfiguration.hasRegister ? 'has-register' : ''}`}>
        { this.state.messagesList.map( renderMessage) }
      </div>
    );
  }

  renderInputBox() {
    const toggleShowOptions = event => {
      this.setState({ showOptions: !this.state.showOptions, pageX: event.pageX, pageY: event.pageY });    // REVIEW event.page?
    }
    // const toggleShowOptions = _ => this.setState({ showOptions: !this.state.showOptions });   // REVIEW considerar esta alternativa
    const toggleShowDate = _ => this.setState({ showDate: !this.state.showDate });
    const toggleShowTime = _ => this.setState({ showTime: !this.state.showTime });

    const renderOptions = _ => (
      <div className={'options'}>
        <h4>CHAT OPTIONS</h4>
        <hr />
        <div className={'checkbox'}>
          <input type='checkbox' checked={this.state.showDate} onChange={ toggleShowDate } />
          <label>Mostrar Fecha</label>
        </div>
        <div className={'checkbox'}>
          <input type='checkbox' checked={this.state.showTime} onChange={ toggleShowTime } />
          <label>Mostrar Hora</label>
        </div>
      </div>
    );

    const enterHandler = async event => {
      if( event.key === 'Enter') await this.publishMessage();
    };
  
    return (
      <div className={'input-box'}>
        <textarea className={'form-control input-message'} onKeyDown={ enterHandler } ref={ ref => this.inputField = ref} />
        <div className='column-6'>
          <button className={'btn-chat'} onClick={ toggleShowOptions }> Opciones </button>
          { this.state.showOptions ? renderOptions() : <div/> }
        </div>
        <div className='column-6'>
          <button className={'btn-chat pull-right'} onClick={ this.publishMessage }> Enviar </button>
        </div>
      </div>
    );
  }

  renderForm() {
    const FormsWithFormBar = [ Forms.Login, Forms.Register ];

    const renderFormBar = _ => (
      <div>
        <SocialLogin chatConfiguration={ this.props.chatConfiguration } clearForm={ this.clearForm } setLogin={ this.setLogin }/>
        <hr />
        <div className={'tab'}>
          <button
            className={(this.state.renderForm === Forms.Login) ? 'tab-active' : ''}
            onClick={ _ => this.setForm( Forms.Login) }
          >Log In</button>
          <button
            className={(this.state.renderForm === Forms.Register) ? 'tab-active' : ''}
            onClick={ _ => this.setForm( Forms.Register) }
          >Sign Up</button>
        </div>
        <br />
      </div>
    );

    const renderFormInputs = _ => {
      switch( this.state.renderForm) {
        case Forms.ChangePassword:
          return <ChangePassword chatConfiguration={ this.props.chatConfiguration } clearForm={ this.clearForm }/>;
        case Forms.Login:
          return <Login chatConfiguration={ this.props.chatConfiguration } clearForm={ this.clearForm } setLogin={ this.setLogin }/>;
        case Forms.Register:
          return <Register chatConfiguration={ this.props.chatConfiguration } clearForm={ this.clearForm }/>;
        case Forms.UserName:
          return <UserName chatConfiguration={ this.props.chatConfiguration } clearForm={ this.clearForm } setUserName={ this.setUserName }/>;
        case null:
          return <div/>;
        default:
          console.warn( new Date(), 'Trying to display an unrecognize Form.');
          return <div warn='Trying to display an unrecognize Form.'/>;
      }
    };

    return (
      <div className={`form ${this.state.renderForm}`}>
        { IE11_safeIncludes( FormsWithFormBar, this.state.renderForm) ? renderFormBar() : <div/> }
        { renderFormInputs() }
      </div>
    );
  }

  render() {
    const width = (1 - this.props.chatConfiguration.widthFactor) * window.innerWidth;
    const height = window.innerHeight;

    return (
      <div className={`sidebar ${this.props.chatConfiguration.style}`} style={{ width, height }}>
        { this.renderTitleBox() }
        { this.renderMessageBox() }
        { this.renderInputBox() }
        { this.renderForm() }
      </div>
    );
  }

  componentDidUpdate() {
    if( this.mustScroll && this.lastMessage) {
      this.mustScroll = false;
      this.lastMessage.scrollIntoView();
    }
    if( this.mustFocus) {
      this.mustFocus = false;
      ReactDOM.findDOMNode( this.inputField).focus();
    }
  }

  componentDidMount() {
    this.loadMessages();
    this.refreshInterval = setInterval( _ =>{
      this.loadMessages();
    }, this.props.chatConfiguration.refreshInterval);
  }

  componentWillUnmount() {
    if( this.refreshInterval) {
      clearInterval( this.refreshInterval);
    }
  }

}

export default ChatSidebar;
